import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=6c747220&scoped=true"
import script from "./Download.vue?vue&type=script&setup=true&lang=js"
export * from "./Download.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Download.vue?vue&type=style&index=0&id=6c747220&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c747220",
  null
  
)

export default component.exports